module.exports = __webpack_public_path__ + "img/web_tf_logo.b0957b78.png";